import { IOrderDetails } from '@/models/orders.model';
import { TUpdateOrderDeliveryFormValues, UpdateOrderDeliveryFormFieldsNames } from '.';

export const getDeliveryFormValues = (order: IOrderDetails | null): TUpdateOrderDeliveryFormValues | undefined => {
  if (!order?.delivery) {
    return undefined;
  }

  const { delivery } = order;

  return {
    [UpdateOrderDeliveryFormFieldsNames.DELIVERY_TYPE]: delivery.delivery,
    [UpdateOrderDeliveryFormFieldsNames.SETTLEMENT]: delivery.settlement_id,
    [UpdateOrderDeliveryFormFieldsNames.COMMENT]: delivery.comment,
    [UpdateOrderDeliveryFormFieldsNames.ADDRESS]: delivery.address,
    [UpdateOrderDeliveryFormFieldsNames.BUILDING_TYPE]: delivery.building_type,
    [UpdateOrderDeliveryFormFieldsNames.FLOOR]: delivery.floor,
    [UpdateOrderDeliveryFormFieldsNames.FLAT_NUMBER]: delivery.flat_number,
    [UpdateOrderDeliveryFormFieldsNames.ELEVATOR]: delivery.freight_elevator ? '1' : '0',
    [UpdateOrderDeliveryFormFieldsNames.DELIVERY_DEPARTMENT]: delivery.delivery_department,
    [UpdateOrderDeliveryFormFieldsNames.DELIVERY_WAREHOUSE]: delivery.delivery_warehouse_id,
  };
};
